/* ==========================================================================
   Foldinn theme
   No framework, no build step. Everything is event delegation on `document`,
   so markup replaced by the Section Rendering API keeps working without
   re-binding a single listener.
   ========================================================================== */

(function () {
  'use strict';

  var DF = window.DF || {};
  var $  = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ------------------------------------------------------------- money ---
     Shopify hands us the shop's money format string. Rendering prices in JS
     has to match what Liquid renders server-side or the page looks buggy the
     moment a variant changes. */

  function formatMoney(cents, format) {
    var fmt = format || DF.moneyFormat || '{{ amount }}';
    var value = typeof cents === 'string' ? cents.replace('.', '') : cents;

    function thousands(number, sep, decSep, decimals) {
      if (isNaN(number) || number === null) return 0;
      number = (number / 100.0).toFixed(decimals);
      var parts = number.split('.');
      var head  = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + sep);
      var tail  = parts[1] ? decSep + parts[1] : '';
      return head + tail;
    }

    var out = '';
    var match = /\{\{\s*(\w+)\s*\}\}/.exec(fmt);
    var placeholder = match ? match[1] : 'amount';

    switch (placeholder) {
      case 'amount':                                out = thousands(value, ',', '.', 2); break;
      case 'amount_no_decimals':                    out = thousands(value, ',', '.', 0); break;
      case 'amount_with_comma_separator':           out = thousands(value, '.', ',', 2); break;
      case 'amount_no_decimals_with_comma_separator': out = thousands(value, '.', ',', 0); break;
      case 'amount_with_space_separator':           out = thousands(value, ' ', ',', 2); break;
      case 'amount_no_decimals_with_space_separator': out = thousands(value, ' ', ',', 0); break;
      default:                                      out = thousands(value, ',', '.', 2);
    }

    return fmt.replace(/\{\{\s*\w+\s*\}\}/, out);
  }

  /* ------------------------------------------------------------ drawers --- */

  var lastFocused = null;

  function openDrawer(id) {
    var drawer = document.getElementById(id);
    if (!drawer) return;
    lastFocused = document.activeElement;
    drawer.classList.add('is-open');
    drawer.removeAttribute('aria-hidden');
    document.body.style.overflow = 'hidden';
    var focusTarget = drawer.querySelector('[data-drawer-close]');
    if (focusTarget) focusTarget.focus();
  }

  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  function closeAllDrawers() {
    $$('.df-drawer.is-open').forEach(closeDrawer);
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      openDrawer(opener.getAttribute('data-drawer-open'));
      return;
    }

    var closer = e.target.closest('[data-drawer-close]');
    if (closer) {
      e.preventDefault();
      closeDrawer(closer.closest('.df-drawer'));
      return;
    }

    if (e.target.classList && e.target.classList.contains('df-drawer__backdrop')) {
      closeDrawer(e.target.closest('.df-drawer'));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var openModal = $('.df-modal:not([hidden])');
    if (openModal) { closeModal(openModal); return; }
    closeAllDrawers();
  });

  /* -------------------------------------------------------------- modal --- */

  function openModal(modal) {
    if (!modal) return;
    lastFocused = document.activeElement;
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    var close = modal.querySelector('[data-modal-close]');
    if (close) close.focus();
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.hidden = true;
    document.body.style.overflow = '';
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-modal-open]');
    if (opener) {
      e.preventDefault();
      openModal(document.getElementById(opener.getAttribute('data-modal-open')));
      return;
    }
    var closer = e.target.closest('[data-modal-close]');
    if (closer) {
      e.preventDefault();
      closeModal(closer.closest('.df-modal'));
      return;
    }
    if (e.target.classList && e.target.classList.contains('df-modal')) closeModal(e.target);
  });

  /* --------------------------------------------------------------- cart --- */

  function refreshCartSection() {
    return fetch(DF.routes.root + '?sections=cart-drawer', { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var host = document.getElementById('shopify-section-cart-drawer');
        if (!host || !data['cart-drawer']) return;
        var doc = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
        var fresh = doc.getElementById('shopify-section-cart-drawer');
        // Preserve the open state across the swap.
        var wasOpen = !!host.querySelector('.df-drawer.is-open');
        host.innerHTML = fresh ? fresh.innerHTML : doc.body.innerHTML;
        if (wasOpen) {
          var drawer = host.querySelector('.df-drawer');
          if (drawer) drawer.classList.add('is-open');
        }
      })
      .catch(function () { /* leave the old markup in place rather than blanking the cart */ });
  }

  function refreshCartCount() {
    return fetch(DF.routes.cart + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        return cart;
      })
      .catch(function () { return null; });
  }

  function setBusy(button, busy) {
    if (!button) return;
    if (busy) {
      button.dataset.idleLabel = button.dataset.idleLabel || button.textContent;
      button.setAttribute('aria-disabled', 'true');
      button.textContent = 'Adding…';
    } else {
      button.removeAttribute('aria-disabled');
      if (button.dataset.idleLabel) button.textContent = button.dataset.idleLabel;
    }
  }

  function showFormError(form, message) {
    var box = form.querySelector('[data-form-error]');
    if (!box) return;
    box.textContent = message || 'Sorry, that could not be added to your cart.';
    box.hidden = !message;
  }

  // Add to cart, without leaving the page.
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form || !DF.cartDrawer) return;

    e.preventDefault();
    // The button the customer actually pressed, not simply the first submit in
    // the form — the product form has two (Add to cart and Buy it now), and
    // querySelector would spin the wrong one.
    var button = e.submitter || form.querySelector('[type="submit"]');
    var buyNow = !!(button && button.hasAttribute('data-buy-now'));
    showFormError(form, '');
    setBusy(button, true);

    var body = new FormData(form);
    body.append('sections', 'cart-drawer');

    fetch(DF.routes.cartAdd, {
      method: 'POST',
      headers: { 'Accept': 'application/javascript' },
      body: body
    })
      .then(function (r) { return r.json().then(function (json) { return { ok: r.ok, json: json }; }); })
      .then(function (res) {
        if (!res.ok) {
          setBusy(button, false);
          showFormError(form, res.json.description || res.json.message);
          return;
        }
        if (buyNow) {
          // Straight to checkout. The button is left in its busy state on
          // purpose: releasing it here would flash "Buy it now" again for the
          // moment before the browser navigates, which reads as a failed click
          // and invites a second press.
          // Built off root rather than hard-coded "/checkout": Shopify has no
          // routes.checkout_url, and root carries any locale prefix.
          window.location.href = (DF.routes.root || '/').replace(/\/$/, '') + '/checkout';
          return;
        }
        setBusy(button, false);
        return Promise.all([refreshCartSection(), refreshCartCount()]).then(function () {
          openDrawer('CartDrawer');
        });
      })
      .catch(function () {
        setBusy(button, false);
        // Network trouble on a mobile connection: fall back to the real form
        // post rather than silently swallowing the customer's intent.
        form.submit();
      });
  });

  // Buy it now leaves its button reading "Adding…" on purpose while the browser
  // navigates to checkout. Coming Back from checkout restores this page from the
  // back-forward cache exactly as it was left — button still busy, and the busy
  // style sets pointer-events:none, so it comes back dead rather than merely
  // looking wrong. Clear it on every pageshow: on a fresh load nothing is busy,
  // so this only ever has an effect on a restore.
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('[data-idle-label]').forEach(function (button) {
      setBusy(button, false);
    });
  });

  // Quantity change / remove inside the cart.
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-cart-change]');
    if (!trigger) return;
    e.preventDefault();
    changeLine(trigger.getAttribute('data-line'), trigger.getAttribute('data-cart-change'));
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty]');
    if (!input) return;
    changeLine(input.getAttribute('data-line'), input.value);
  });

  function changeLine(line, quantity) {
    if (!line) return;
    fetch(DF.routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify({ line: Number(line), quantity: Number(quantity) })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return Promise.all([refreshCartSection(), refreshCartCount()]); })
      .catch(function () { window.location = DF.routes.cart; });
  }

  /* ---------------------------------------------------- quantity steppers --- */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-step]');
    if (!btn) return;
    e.preventDefault();
    var wrap  = btn.closest('.df-qty');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;

    var step = Number(btn.getAttribute('data-qty-step'));
    var min  = Number(input.min || 1);
    var next = Math.max(min, (Number(input.value) || min) + step);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ------------------------------------------------------- variant picker --- */

  function initProductForm(root) {
    var dataEl = root.querySelector('[data-variant-data]');
    if (!dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

    var mediaMap = {};
    var mediaEl = root.querySelector('[data-colour-media]');
    if (mediaEl) { try { mediaMap = JSON.parse(mediaEl.textContent); } catch (err) { mediaMap = {}; } }

    var idInput  = root.querySelector('[data-variant-id]');
    var priceBox = root.querySelector('[data-price-box]');
    var addBtn   = root.querySelector('[data-add-button]');
    var stockBox = root.querySelector('[data-stock]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var lowAt    = Number(root.getAttribute('data-low-stock-at') || 5);

    function selectedOptions() {
      return $$('[data-option-index]', root)
        .filter(function (i) { return i.checked; })
        .sort(function (a, b) {
          return Number(a.getAttribute('data-option-index')) - Number(b.getAttribute('data-option-index'));
        })
        .map(function (i) { return i.value; });
    }

    function findVariant(opts) {
      return variants.filter(function (v) {
        return v.options.length === opts.length && v.options.every(function (o, i) { return o === opts[i]; });
      })[0];
    }

    // Grey out sizes that don't exist for the chosen colour, instead of
    // letting someone pick a combination and hit an error at the button.
    function updateAvailability(opts) {
      $$('[data-option-index]', root).forEach(function (input) {
        var index = Number(input.getAttribute('data-option-index'));
        if (index === 0) return;
        var probe = opts.slice();
        probe[index] = input.value;
        var match = variants.filter(function (v) {
          for (var i = 0; i <= index; i++) { if (v.options[i] !== probe[i]) return false; }
          return true;
        });
        var sellable = match.some(function (v) { return v.available; });
        input.disabled = match.length > 0 && !sellable;
      });
    }

    function renderPrice(variant) {
      if (!priceBox) return;
      var html = '<span class="df-price__now">' + formatMoney(variant.price) + '</span>';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        var save = Math.round((1 - variant.price / variant.compare_at_price) * 100);
        html += '<s class="df-price__was">' + formatMoney(variant.compare_at_price) + '</s>' +
                '<span class="df-price__save">Save ' + save + '%</span>';
      }
      priceBox.innerHTML = html;
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
    }

    function renderStock(variant) {
      if (!stockBox) return;
      if (!variant.available) {
        stockBox.className = 'df-stock df-stock--out';
        stockBox.textContent = 'Out of stock';
        return;
      }
      if (variant.inventory_management && variant.inventory_quantity > 0 && variant.inventory_quantity <= lowAt) {
        stockBox.className = 'df-stock df-stock--low';
        stockBox.textContent = 'Only ' + variant.inventory_quantity + ' left';
        return;
      }
      stockBox.className = 'df-stock';
      stockBox.textContent = 'In stock, ready to ship';
    }

    // Variants carry no image on this product, so colour is matched to media
    // by name through a map the section builds from the media alt text.
    function showColourMedia(colour) {
      var index = mediaMap[colour];
      if (index === undefined) return;
      var thumb = document.querySelector('[data-media-index="' + index + '"]');
      if (thumb) thumb.click();
    }

    function update() {
      var opts = selectedOptions();
      updateAvailability(opts);
      var variant = findVariant(opts);

      $$('[data-option-selected]', root).forEach(function (el) {
        var i = Number(el.getAttribute('data-option-selected'));
        if (opts[i]) el.textContent = opts[i];
      });

      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = DF.strings.unavailable; }
        return;
      }

      if (idInput) idInput.value = variant.id;
      renderPrice(variant);
      renderStock(variant);
      if (opts[0]) showColourMedia(opts[0]);

      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? DF.strings.addToCart : DF.strings.soldOut;
      }

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-option-index]')) update();
    });

    update();
  }

  /* -------------------------------------------------------- media gallery --- */

  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-media-index]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-gallery]');
    if (!gallery) return;

    var src = thumb.getAttribute('data-media-src');
    var alt = thumb.getAttribute('data-media-alt') || '';
    var main = gallery.querySelector('[data-gallery-main]');
    if (main && src) {
      main.src = src;
      main.alt = alt;
      main.removeAttribute('srcset');
    }
    $$('[data-media-index]', gallery).forEach(function (t) {
      t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
    });
  });

  /* ---------------------------------------------------------- sticky ATC --- */

  function initStickyAtc() {
    var bar = $('[data-sticky-atc]');
    if (!bar) return;

    var realBtn = $('[data-add-button]');
    if (!realBtn) { bar.remove(); return; }

    document.body.classList.add('has-sticky-atc');

    var stickyBtn = bar.querySelector('[data-sticky-btn]');
    if (stickyBtn) {
      // Click the real button rather than reimplementing the cart, so variant
      // handling, the drawer and error states are all inherited.
      stickyBtn.addEventListener('click', function (ev) {
        ev.preventDefault();
        if (realBtn.disabled) return;
        realBtn.click();
      });

      var sync = function () {
        stickyBtn.disabled = realBtn.disabled;
        stickyBtn.textContent = realBtn.disabled ? DF.strings.soldOut : DF.strings.addToCart;
      };
      sync();
      new MutationObserver(sync).observe(realBtn, { attributes: true, attributeFilter: ['disabled'] });
    }

    if (!('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { rootMargin: '0px 0px -40px 0px', threshold: 0 }).observe(realBtn);
  }

  /* --------------------------------------------------- announcement bar --- */

  function initAnnouncement() {
    var bar = $('[data-announcement]');
    if (!bar) return;
    var slides = $$('.df-announcement__slide', bar);
    if (slides.length < 2) return;

    var delay = Number(bar.getAttribute('data-rotate')) || 5;
    var i = 0;
    setInterval(function () {
      slides[i].classList.remove('is-active');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-active');
    }, delay * 1000);
  }

  /* ------------------------------------------------------------ carousel ---
     Scrolling itself is native (overflow-x + scroll-snap), so a swipe works
     with this file blocked. All we add is the arrows, and they only appear
     once we know the track actually overflows. */

  function initCarousel(el) {
    if (el.dfCarousel) return;             // survives shopify:section:load
    el.dfCarousel = true;

    var track = $('[data-carousel-track]', el);
    var prev  = $('[data-carousel-prev]', el);
    var next  = $('[data-carousel-next]', el);
    if (!track || !prev || !next) return;

    function step() {
      var item = track.firstElementChild;
      if (!item) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return item.getBoundingClientRect().width + gap;
    }

    function sync() {
      // 2px of slack: sub-pixel widths mean scrollWidth is rarely exact.
      var overflowing = track.scrollWidth - track.clientWidth > 2;
      el.classList.toggle('is-overflowing', overflowing);
      prev.hidden = !overflowing;
      next.hidden = !overflowing;
      if (!overflowing) return;

      var max = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max - 2;
    }

    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left:  step(), behavior: 'smooth' }); });

    var raf;
    track.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(sync);
    }, { passive: true });

    if (window.ResizeObserver) {
      new ResizeObserver(sync).observe(track);
    } else {
      window.addEventListener('resize', sync);
    }

    sync();
  }

  /* ------------------------------------------------------------ wishlist ---
     Saved in localStorage only. There is no wishlist page and nothing reaches
     the server — this remembers the hearts between visits on this device and
     nothing more. A real cross-device wishlist needs an app. */

  var WISH_KEY = 'df:wishlist';

  function readWishlist() {
    try {
      var raw = localStorage.getItem(WISH_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Object.prototype.toString.call(list) === '[object Array]' ? list : [];
    } catch (e) {
      return [];                            // private mode, quota, corrupt JSON
    }
  }

  function writeWishlist(list) {
    try { localStorage.setItem(WISH_KEY, JSON.stringify(list)); } catch (e) {}
  }

  function paintWishlist(scope) {
    var saved = readWishlist();
    $$('[data-wish]', scope || document).forEach(function (btn) {
      var on = saved.indexOf(btn.getAttribute('data-wish')) !== -1;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-wish]') : null;
    if (!btn) return;
    e.preventDefault();

    var id    = btn.getAttribute('data-wish');
    var list  = readWishlist();
    var at    = list.indexOf(id);
    var addng = at === -1;

    if (addng) { list.push(id); } else { list.splice(at, 1); }
    writeWishlist(list);

    // Every card for this product, in case it appears in more than one row.
    $$('[data-wish="' + id + '"]').forEach(function (b) {
      b.setAttribute('aria-pressed', addng ? 'true' : 'false');
    });
  });

  /* ------------------------------------------------ Shop our Instagram ---- */

  /**
   * Builds the reel cards from the JSON block written by sync-ig-reels.js.
   *
   * The section ships hidden and is revealed only once at least one card is
   * built, so a stale or empty payload leaves no orphaned heading behind.
   * Everything coming from Instagram is third-party text and is treated as
   * such: captions go in with textContent, and URLs are scheme-checked.
   */
  function initIgShop(el) {
    if (el.dfIgShop) return;
    el.dfIgShop = true;

    var track  = $('[data-ig-track]', el);
    var tpl    = document.querySelector('[data-ig-card-template]');
    var dataEl = document.querySelector('[data-ig-reels]');
    if (!track || !tpl || !dataEl) return;

    var payload;
    try { payload = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var items = (payload && payload.items) || [];
    if (!items.length) return;

    items.forEach(function (item) {
      var poster = safeHttpUrl(item.poster);
      if (!poster) return;                      // a card with no image is not a card

      var node = tpl.content.cloneNode(true);
      var item_el = $('.df-carousel__item', node);
      var card = $('.df-ig__card', node);
      var img  = $('.df-ig__poster', node);
      var bag  = $('[data-ig-bag]', node);

      img.alt = item.caption || ('Reel by ' + (item.username || 'us'));
      $('[data-ig-user]', node).textContent = item.username || '';
      $('[data-ig-caption]', node).textContent = item.caption || '';

      card.dataset.igUser = item.username || '';
      var video = safeHttpUrl(item.video);
      if (video) {
        $('[data-ig-video]', node).dataset.src = video;
      } else {
        // Nothing to play: drop the badge rather than leave a play button that
        // does nothing when pressed.
        $('[data-ig-play]', node).remove();
        card.disabled = true;
      }

      if (item.product) {
        bag.href = productUrl(item.product);
        bag.hidden = false;
      }

      // The URL is parked in a data attribute; watchPosters promotes it to src
      // when the card is actually approached. Native loading="lazy" is not
      // enough here: its distance threshold is generous enough to pull an
      // entire horizontal row at once, which is exactly what it did — 151 KB
      // for a row sitting 2,300px below the fold.
      img.dataset.src = poster;

      track.appendChild(node);
    });

    if (!track.children.length) return;
    el.hidden = false;
    watchPosters(track);
    initIgPlayback(track);
  }

  /**
   * Plays a reel inside its own card — hover on a mouse, tap on touch.
   *
   * The video file is not even referenced until the pointer arrives, so a card
   * costs its poster and nothing else until someone shows interest. Only one
   * reel plays at a time; leaving a card rewinds it, so coming back starts from
   * the top rather than resuming half way through.
   */
  function initIgPlayback(track) {
    var playing = null;
    var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    function start(card) {
      var video = $('[data-ig-video]', card);
      if (!video || !video.dataset.src && !video.src) return;

      if (playing && playing !== video) stop(playing.closest('[data-ig-open]'));

      if (video.dataset.src) {                  // first play: attach the file
        video.src = video.dataset.src;
        delete video.dataset.src;
      }
      var p = video.play();
      if (p && p.catch) {
        // A refused autoplay must not leave the card looking mid-play.
        p.then(function () { card.classList.add('is-playing'); playing = video; })
         .catch(function () { card.classList.remove('is-playing'); });
      } else {
        card.classList.add('is-playing');
        playing = video;
      }
    }

    function stop(card) {
      if (!card) return;
      var video = $('[data-ig-video]', card);
      if (!video) return;
      video.pause();
      video.currentTime = 0;
      card.classList.remove('is-playing');
      if (playing === video) playing = null;
    }

    if (canHover) {
      // Hover intent. Without the pause, dragging the mouse across the row
      // starts every card it crosses and each one immediately buffers ahead:
      // measured at 1.8 MB for a couple of seconds of casual hovering. A short
      // rest means only a card someone actually stopped on ever loads.
      var HOVER_INTENT = 180;
      var pending = null;

      track.addEventListener('pointerenter', function (e) {
        var card = e.target.closest('[data-ig-open]');
        if (!card || card.disabled) return;
        clearTimeout(pending);
        pending = setTimeout(function () { start(card); }, HOVER_INTENT);
      }, true);

      track.addEventListener('pointerleave', function (e) {
        var card = e.target.closest('[data-ig-open]');
        if (!card) return;
        clearTimeout(pending);
        stop(card);
      }, true);
    }

    // Click is bound on both: it is the only way in on touch, and on desktop it
    // lets someone pause a reel that hover started.
    track.addEventListener('click', function (e) {
      var card = e.target.closest('[data-ig-open]');
      if (!card || card.disabled) return;
      var video = $('[data-ig-video]', card);
      if (video && !video.paused) { stop(card); } else { start(card); }
    });

    // A reel scrolled out of the row should not keep playing off-screen.
    track.addEventListener('scroll', function () {
      if (!playing) return;
      var card = playing.closest('[data-ig-open]');
      var a = card.getBoundingClientRect(), b = track.getBoundingClientRect();
      if (a.right < b.left || a.left > b.right) stop(card);
    }, { passive: true });
  }

  /**
   * Loads a poster only once its card comes near the viewport, and near the
   * visible part of the row — so landing on the homepage costs nothing, and
   * sliding the row fetches the next few as they are approached.
   *
   * Two observers, because there are two independent axes: the page scrolls
   * vertically past the section, and the row scrolls horizontally within it.
   * A single observer against the viewport would treat every card in the row as
   * visible the moment the section is reached.
   */
  function watchPosters(track) {
    var imgs = $$('.df-ig__poster[data-src]', track);
    if (!imgs.length) return;

    function load(img) {
      if (!img.dataset.src) return;
      img.src = img.dataset.src;
      delete img.dataset.src;
    }

    if (!('IntersectionObserver' in window)) {
      imgs.forEach(load);                       // old browser: correctness over thrift
      return;
    }

    // Horizontal: is the card near the visible slice of the row?
    var inRow = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        load(entry.target);
        obs.unobserve(entry.target);
      });
    }, { root: track, rootMargin: '0px 300px' });

    // Vertical: don't start any of it until the section itself is approached.
    var nearPage = new IntersectionObserver(function (entries, obs) {
      if (!entries.some(function (e) { return e.isIntersecting; })) return;
      obs.disconnect();
      imgs.forEach(function (img) { inRow.observe(img); });
    }, { rootMargin: '400px 0px' });

    nearPage.observe(track);
  }

  /**
   * Only ever follow http(s) or a same-origin path out of this data — it comes
   * from Instagram, so `javascript:` and friends must not survive.
   * Root-relative is accepted because asset_url renders rehosted posters as
   * "/cdn/shop/t/9/assets/…", not as an absolute URL.
   */
  function safeHttpUrl(u) {
    u = u || '';
    if (/^\/(?!\/)/.test(u)) return u;              // same-origin path
    return /^(https?:)?\/\//i.test(u) ? u : '';     // absolute or protocol-relative
  }

  function productUrl(handle) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/$/, '') + '/products/' + encodeURIComponent(handle);
  }


  /* ---------------------------------------------------------------- boot --- */

  function boot(scope) {
    $$('[data-product-form]', scope || document).forEach(initProductForm);
    // Reels are built before the carousels so overflow measurement sees them.
    $$('[data-ig-shop]', scope || document).forEach(initIgShop);
    $$('[data-carousel]', scope || document).forEach(initCarousel);
    paintWishlist(scope);
    initStickyAtc();
    initAnnouncement();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  // Theme editor: re-run for a section the merchant just edited.
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });

  window.DFTheme = { refreshCartSection: refreshCartSection, refreshCartCount: refreshCartCount, formatMoney: formatMoney };
})();
